import classnames from "classnames";
import React from "react";
import OpeningHours from "../opening-hours/OpeningHours";
import LiveChatButton from "../../../live-chat-button/LiveChatButton";
import { Badge } from "@JohnLewisPartnership/jl-design-system/dist/components/badge/Badge";
import { TickCircleFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickCircleFilled";
import ContactLiveChatUnavailable from "../contact-live-chat-unavailable/ContactLiveChatUnavailable";

import styles from "./contact-chat.module.scss";

const liveChatDescriptions = [
  "Our fast, text-based chat service",
  "Our chatbot can connect you with a Partner",
  "Send photos and save the chat for your records",
];

function ContactLiveChat({ className, config, location, displayOpeningHours = true }) {
  const { channel, open, displayTimes, percentage } = config;
  const getIfEnabled = () => Math.random() < percentage / 100;

  const openChatOption = () => {
    return (
      <>
        <div>
          <div className={styles.liveChatHeader}>
            <h4 className={styles["contact-chat__new-title"]}>Live chat</h4>
            <Badge badgeType="--success" className="custom-class-name" label="Recommended" />
          </div>
          {liveChatDescriptions.map(desc => (
            <div key={desc} className={styles.liveChatDescription}>
              <div>
                <TickCircleFilled />
              </div>
              <p>{desc}</p>
            </div>
          ))}
        </div>
        <div className={styles["contact-chat__button"]}>
          <LiveChatButton channel={channel} buttonLocation={location} showChatIcon />
        </div>
        {displayOpeningHours && <OpeningHours openingHours={displayTimes} />}
      </>
    );
  };

  const getChatDOM = () => {
    if (!getIfEnabled() || !open) {
      return <ContactLiveChatUnavailable config={config} showGreyBackground={false} />;
    }
    return openChatOption();
  };

  return (
    <div className={classnames(className, styles["contact-chat"])} data-test="container-chat">
      {getChatDOM()}
    </div>
  );
}

export default ContactLiveChat;
